module.exports = __webpack_public_path__ + "img/scene22.e72dea85.gif";